import init from "./init.js";
import unmount from "./unmount.js";

export { init, unmount };
export default { init, unmount };
